var map = {
	"./RESPONSIBLE_AI/AI3S_d1_01.png": 1032,
	"./RESPONSIBLE_AI/AI3S_d1_02.png": 148,
	"./RESPONSIBLE_AI/AI3S_d1_03.png": 2116,
	"./RESPONSIBLE_AI/AI3S_d1_04.png": 8300,
	"./RESPONSIBLE_AI/AI3S_d1_05.png": 8496,
	"./RESPONSIBLE_AI/AI3S_d1_06.png": 2112,
	"./RESPONSIBLE_AI/AI3S_d1_10.png": 1728,
	"./RESPONSIBLE_AI/AI3S_demo_1.png": 4932,
	"./RESPONSIBLE_AI/AI3S_demo_2_computer.png": 4864,
	"./RESPONSIBLE_AI/AI3S_demo_2_paper.png": 5880,
	"./RESPONSIBLE_AI/AI3S_demo_2_shield.png": 7084,
	"./RESPONSIBLE_AI/AI3S_demo_3_alert_message.png": 8748,
	"./RESPONSIBLE_AI/AI3S_demo_3_bubble.png": 164,
	"./RESPONSIBLE_AI/AI3S_demo_3_close_icon.png": 6676,
	"./RESPONSIBLE_AI/AI3S_demo_3_computer.png": 6880,
	"./RESPONSIBLE_AI/AI3S_demo_3_person.png": 3529,
	"./RESPONSIBLE_AI/AI3S_demo_4_computer.png": 4904,
	"./RESPONSIBLE_AI/AI3S_demo_4_fire.png": 3236,
	"./RESPONSIBLE_AI/AI3S_demo_4_light.png": 2600,
	"./RESPONSIBLE_AI/AI3S_demo_4_lock.png": 5736,
	"./RESPONSIBLE_AI/AI3S_demo_5_computer.png": 100,
	"./RESPONSIBLE_AI/AI3S_demo_5_magnifying_glass.png": 6940,
	"./RESPONSIBLE_AI/AI3S_demo_5_stats.png": 1356,
	"./STS/STS_intro_01.png": 5624,
	"./TRANSFORMER/TRANSFORMER_intro_01.png": 9952,
	"./TURF_OPTIMIZATION/TO_DEMO_1.png": 3352,
	"./TURF_OPTIMIZATION/TO_DEMO_2_1.png": 8916,
	"./TURF_OPTIMIZATION/TO_DEMO_2_2.png": 4852,
	"./TURF_OPTIMIZATION/TO_DEMO_3_1.png": 212,
	"./TURF_OPTIMIZATION/TO_DEMO_3_2.png": 3588,
	"./TURF_OPTIMIZATION/TO_DEMO_4_1.png": 3652,
	"./TURF_OPTIMIZATION/TO_DEMO_4_2.png": 3844,
	"./TURF_OPTIMIZATION/TO_Demo_1_name.png": 6376,
	"./TURF_OPTIMIZATION/TO_bg_1.png": 9408,
	"./TURF_OPTIMIZATION/TO_bg_2.png": 2892,
	"./TURF_OPTIMIZATION/TO_bg_3.png": 2423,
	"./TURF_OPTIMIZATION/TO_bg_4.png": 1640,
	"./characters/character_1.png": 1848,
	"./characters/character_to_1.gif": 4600,
	"./characters/character_to_1.png": 2836,
	"./icons_labels/start.png": 748,
	"./topaz.png": 2532
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4276;